import styled from 'styled-components';

export const HighlightStyled = styled.span`
  font-weight: bold;
`;
